import Vue from 'vue';
import VueRouter from 'vue-router';
import VueObserveVisibility from 'vue-observe-visibility';
import vueDebounce from 'vue-debounce';
import InstantSearch from 'vue-instantsearch';
import Snotify from 'vue-snotify';
import algoliasearch from 'algoliasearch';
import algoliaHelper from 'algoliasearch-helper';
import algoliaConfig from './algolia-config';
import SloanComponentLibrary from '../../lib';

const algoliaClient = algoliasearch(
  algoliaConfig.algoliaAppId,
  algoliaConfig.algoliaApiKey,
  {protocol: 'https:'}
);

Vue.use(VueRouter);
Vue.use(VueObserveVisibility);
Vue.use(vueDebounce);
Vue.use(InstantSearch);
Vue.use(SloanComponentLibrary);
Vue.use(Snotify, {
  toast: {
    timeout: 2500,
    position: 'centerTop',
    showProgressBar: true
  }
});

Vue.prototype.$algolia = {
  client: algoliaClient,
  helper: algoliaHelper,
  appId: algoliaConfig.algoliaAppId,
  apiKey: algoliaConfig.algoliaApiKey,
  indexPrefix: algoliaConfig.algoliaIndexPrefix + '_'
};

Vue.options.delimiters = ['[[', ']]'];

export default Vue;
